import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { AdditionalInfo, Button, Format } from 'src/Components'

import styles from './Step.module.scss'

const CMASectionCorrectness = ({ avm, setAnswer }) => {
  const handleAnswer = answer => () => {
    setAnswer({ question: 'isEstimateCorrect', answer })
  }

  return (
    <Fragment>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.cmaWizard.correctness.headline'
          defaultMessage='Does {homeValue} seem correct?'
          values={{
            homeValue: <Format.Currency abbreviate value={avm} />
          }}
        />
      </AdditionalInfo.Heading>
      <Button.Group className={styles.buttonGroup}>
        <Button onClick={handleAnswer('toolow')}>
          <FormattedMessage
            id='Homeowner.cmaWizard.correctness.tooLowButton'
            defaultMessage="It's too low"
          />
        </Button>
        <Button onClick={handleAnswer('close')}>
          <FormattedMessage
            id='Homeowner.cmaWizard.correctness.seemsCloseButton'
            defaultMessage='Seems close'
          />
        </Button>
        <Button onClick={handleAnswer('toohigh')}>
          <FormattedMessage
            id='Homeowner.cmaWizard.correctness.seemsHighButton'
            defaultMessage="It's too high"
          />
        </Button>
      </Button.Group>
    </Fragment>
  )
}

export default CMASectionCorrectness
